export default "__VITE_ASSET__NoWW1jSC__"